module.exports = __webpack_public_path__ + "static/media/unlink_off.f3ac428a.png";